module.exports = __webpack_public_path__ + "img/cert_template.36fd2668.png";